import Vue from 'vue'

export default {
  SET_LOADING(state, loading) {
    Vue.set(state, 'loading', loading)
  },
  SET_BOLETOS(state, lista) {
    state.boletos = lista
  },
  ADD_BOLETOS(state, boletos) {
    state.boletos = [...state.boletos, ...boletos]
  },
}
